import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import GridDatePicker from '../../../components/common/inputs/GridDatePicker';
import { apiConstant } from './helpers/constant';
import moment from 'moment';
import AutocompleteGridmui from '../../../components/common/autocomplete/AutocompleteGridmui';
import SelectGridMui from '../../../components/common/selectscustom/SelectGridMui';
import { MenuItem } from '@mui/material';

const ModalInput = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [department, setDepartment] = useState([{}]);
  const [moduleData, setMoudleData] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [render, setRender] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Customer' : 'Create Customer'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/${apiConstant.getById}/${id}`)
        .then((res) => setMoudleData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  useEffect(() => {
    axios
      .get(`/api/${apiConstant.departmentAutoComplete}`)
      .then((res) => setDepartment(res.data.results))
      .catch((err) => console.log(err));
  }, []);

  function handleData(e: React.ChangeEvent<HTMLInputElement>) {
    setMoudleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    setIsSubmit(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/${apiConstant.getById}/${id}`, moduleData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post(`/api/${apiConstant.post}`, moduleData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsSubmit(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'sheet_name'}
        name={'sheet_name'}
        html_for={'sheet_name'}
        label_name={'TEST PAPER NAME'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.sheet_name || ''}
        onChange={handleData}
      />
      <SelectGridMui
        lable={'SET STATUS'}
        name="level"
        value={moduleData?.level || ''}
        onChange={(e: any) => {
          setMoudleData((prev: any) => ({
            ...prev,
            [e.target.name]: e.target.value,
          }));
        }}
      >
        <MenuItem value={''}>None</MenuItem>
        <MenuItem value="LEVEL-1">LEVEL-1</MenuItem>
        <MenuItem value="LEVEL-2">LEVEL-2</MenuItem>
      </SelectGridMui>
      <AutocompleteGridmui
        label={'DEPARTMENT'}
        id="department_name"
        option_name="department_name"
        key={'department_name'}
        arrayofObj={department}
        value={moduleData?.department_id || ''}
        onChange={(_, newValue: any) =>
          setMoudleData((prev: any) => ({ ...prev, department_id: newValue }))
        }
        last_child={2}
      />
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default ModalInput;
